import React, { FC, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Consent } from 'scenes/Consent';
import { NotFound } from 'scenes/NotFound';
import { PreferencesCenter } from 'scenes/PreferencesCenter';
import { initLocalization, selectTranslationsInitialized } from 'services/localization';
import { environment as env, envs } from 'services/environment';
import '@atlaskit/css-reset';

import { useAppDispatch, useAppSelector } from '../../hooks';

const App: FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initLocalization());
  }, [dispatch]);

  useEffect(() => {
    const script = document.createElement('script');

    const environment = env().name;

    script.dataset.domain = '01964a8b-758a-751f-b483-0ec1e112bff6';
    if (environment === envs.PROD) {
      script.src = 'https://atl-onetrust-wrapper.atlassian.com/assets/atl-onetrust-wrapper.min.js';
      script.dataset.domain = '01964ae5-b19b-70b7-9a2d-f40c3cdc5ead';
    } else if (environment === envs.STAGE) {
      script.src =
        'https://atl-onetrust-wrapper.stg-east.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
    } else {
      script.src = 'https://atl-onetrust-wrapper.ddev.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js';
    }

    script.dataset.sync = 'false';
    script.dataset.test = (environment !== envs.PROD).toString();
    script.dataset.geofence = 'true';

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const translationsInitialized = useAppSelector(selectTranslationsInitialized);

  return (
    <>
      {translationsInitialized && (
        <Routes>
          <Route path={'/'} element={<PreferencesCenter />} />
          <Route path={'/consent'} element={<Consent />} />
          <Route path={'/not-found'} element={<NotFound />} />
          <Route path={'*'} element={<Navigate to={'/not-found'} replace />} />
        </Routes>
      )}
    </>
  );
};

export default App;
